const svgCache: Map<string, string> = new Map<string, string>();
const maxEntries: number = 100;
// LRU Cache
export const getSvgFromCache = (smiles: string): string => {
  let entry: string;
  if (svgCache.has(smiles)) {
    entry = svgCache.get(smiles);
    svgCache.delete(smiles);
    svgCache.set(smiles, entry);
  }
  return entry;
};

export const setSvgInCache = (smiles: string, svg: string) => {
  svgCache.set(smiles, svg);
  if (svgCache.size >= maxEntries) {
    const keyToDelete = svgCache.keys().next().value;
    svgCache.delete(keyToDelete);
  }
};

export const clearSvgCache = () => {
  svgCache.clear();
};
